import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

export const createDate = (date, format) => {
  if (format && date) {
    return dayjs(date, format);
  }
  if (date) {
    return dayjs(date);
  }
  return dayjs();
};

export const getCurrentDateTime = () => {
  dayjs.extend(utc);
  return dayjs.utc().format();
};

export const guessTimezone = () => {
  dayjs.extend(utc);
  dayjs.extend(timezone);
  return dayjs.tz.guess();
};
